<template>
  <div id="app">
	<router-view />
  </div>
</template>

<script>
import Index from './components/Index.vue'
import './iconfont/iconfont.css'
import './assets/css/tailwind.css'

export default {
  name: 'app',
  components: {
    Index
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
